import { computed } from '@ember/object';
import FileUpload from '@intercom/embercom-composer/lib/file-upload';
import { bool } from '@ember/object/computed';
import { schedule } from '@ember/runloop';
import Em from 'ember';
export default Em.Object.extend({
  uploadsInProgress: 0,
  uploads: null,
  policyUrl: computed('config.appId', function () {
    return `/apps/${this.config.appId}/uploads`;
  }),
  isUploading: bool('uploadsInProgress'),
  init() {
    this._super(...arguments);
    this.set('uploads', []);
    Em.assert('You must provide a startedUploading action', !!this.get('startedUploading'));
    Em.assert('You must provide a finishedUploading action', !!this.get('finishedUploading'));
    Em.assert('You must provide a errorUploading action', !!this.get('errorUploading'));
    Em.assert('You must provide an ajaxService', !!this.get('ajaxService'));
  },
  addUpload(file, onProgress, attributes, url, inline, fetchFile) {
    if (!this.get('config.appId')) {
      throw 'App Id is required by upload manager';
    }
    this.startedUpload();
    let self = this;
    this._addUploadToCache(file, url);
    let promise = new Em.RSVP.Promise(function (resolve, reject) {
      let success = function (policy) {
        if (inline) {
          fetchFile(policy.public_url).then(function () {
            self.doRender();
            self.decrementProperty('uploadsInProgress');
            resolve(policy);
          }, function (error) {
            self.doRender();
            self.decrementProperty('uploadsInProgress');
            self.get('errorUploading')(self._error(file, error.message));
            reject(error);
          });
        } else {
          self.decrementProperty('uploadsInProgress');
          resolve(policy);
        }
      };
      let failure = function (error) {
        self.decrementProperty('uploadsInProgress');
        self.get('errorUploading')(self._error(file, error.message));
        reject(error);
        self.doRender();
      };
      let progress = function (percentComplete) {
        if (onProgress) {
          onProgress(percentComplete);
        }
      };
      self.incrementProperty('uploadsInProgress');
      let fileUpload = self.createFileUpload(file, progress, attributes);
      fileUpload.upload().then(success).catch(failure);
    });
    return promise.finally(() => self.finishedUpload());
  },
  createFileUpload(file, onProgress, attributes) {
    return new FileUpload(file, this.get('policyUrl'), onProgress, attributes, this.get('ajaxService'));
  },
  getFile(url) {
    let fileObject = this.get('uploads').filterBy('url', url);
    return Em.isPresent(fileObject) ? fileObject.get('firstObject').file : null;
  },
  startedUpload() {
    if (!this.get('isUploading')) {
      this.get('startedUploading')();
    }
  },
  finishedUpload() {
    if (!this.get('isUploading')) {
      this.get('finishedUploading')();
    }
  },
  _addUploadToCache(file, url) {
    this.get('uploads').pushObject({
      file,
      url
    });
  },
  _error(file, message) {
    return {
      fileName: file.name,
      fileType: file.type,
      fileSize: file.size,
      message
    };
  },
  doRender() {
    schedule('afterRender', this, function () {
      let renderFunc = this.get('rerender');
      if (renderFunc) {
        renderFunc();
      }
    });
  }
});